module.exports = __webpack_public_path__ + "static/img/Brad-Hill.d63a44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brad-Hill.jpg
// module id = orAv
// module chunks = 0